// React
import React from "react";

// Core
import { getHistory } from "../../Core/Utils/Utils";

// Material-UI (Core)
import { Box, Typography } from "@material-ui/core";

// Custom
import styled from "styled-components";

const StyledBlock = styled(Box)`
    display: flex;
    transition: all 0.3s ease;
    gap: 0;
    position: relative;
    cursor: pointer;
`;

const IconContainer = styled(Box)`
    margin-top: 0;
    display: flex;
    align-items: center;
    align-items: center;
    height: 60px;
    width: 60px;
    justify-content: center;

    svg {
        height: 100% !important;
        width: 100% !important;
    }
`;

interface FooterBlockProps {
    icon?: any;
    title: string;
    path?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    height?: string;
    width?: string;
}

export const FooterMenuBlock: React.FC<FooterBlockProps> = props => {
    const gotoPageCommand = () => {
        if (props.path) {
            getHistory().push(props.path);
        }
    };

    return (
        <StyledBlock id={"footerblock"} onClick={gotoPageCommand} style={props.style!}>
            <Box>
                {props.icon && <props.icon width={props.width} height={props.height} />}
                <Box>
                    <Typography>{props.title}</Typography>
                </Box>
            </Box>
        </StyledBlock>
    );
};
